<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>NTP Server</h4>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-12">
        <textarea v-model="server_object.contents" class="form-control" rows="30"></textarea>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-6">
        <button type="button" class="btn btn-hub-primary" @click="save()">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: function () {
    return {
      file_path: '/etc/systemd/timesyncd.conf'
    }
  },
  computed: {
    ...mapGetters({
      server_object: 'singleServerObject'
    })
  },
  created () {
    this.$store.dispatch('getServerObject', this.file_path)
  },
  methods: {
    save () {
      this.$store.dispatch('editServerObject', { file_path: this.file_path, file_contents: this.server_object.contents })
    }
  }
}
</script>

<style scoped>
</style>
